module.exports = __webpack_public_path__ + "img/success2.3a83403f.svg";